import { render } from "./SingleClientView.vue?vue&type=template&id=b0bf09ac"
import script from "./SingleClientView.vue?vue&type=script&lang=js"
export * from "./SingleClientView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__